module.exports = __webpack_public_path__ + "img/icon-40.7e616400.png";